import Icon from "@ant-design/icons"
import { ReactComponent as SpainFlag } from "./spain.svg"

const SpainFlagIcon = (props: any) => <Icon component={SpainFlag} {...props} />

export default SpainFlagIcon
